module.exports = __webpack_public_path__ + "img/14.499b87fb.jpg";